import { ChangeDetectorRef, Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AppCommonModule } from '@app/components/app.common.module';
import { BaseComponent } from '@app/components/base/base.component';
import { ActivatedRoute, Router } from "@angular/router";
import { GeneralInformationFormComponent } from '../general-information-form/general-information-form.component';
import {
    FinancialSetupService
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/financial-setup.service";
import { FinancialSetupCreationDto, FinancialSetupHistories, FinancialSetupVersion } from "@app/pages/quote/standard-quote/model/financial-setup.model";
import {
  FinancialProductEnum,
  financialProductsList, formatFinancialSetupCompanyDisplay, purchaseOptionTypes, residualValueTypes,
  TaxType,
  taxTypes, warrantyTypes
} from "@app/pages/quote/open-quote/model/open-quote.model";
import { allowedActions } from "@app/core/util/Util";
import {
    DealerType,
    filterDealers,
    filterPersonType,
    filterQuoteType,
    filtersProductType, filterTypes,
    optionsProductTypes
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/filters/filters-form/FilterConfig";
import {
    filterInsuranceLife,
    filtersInsuranceType,
    optionsInsuranceType
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/insurance-parametrics/insurance-form/InsuranceConfig";
import { Permission } from "@app/models/permissions.enum";
import { RolesInternal } from "@app/models/roles.enum";
import { AuthService } from "@app/common/auth.service";
import { ModalService } from '@app/components/modal/modal.service';
import { TemplateHistoryComponent } from '@app/components/template-history/template-history.component';
import { StatusHistory } from '@app/models/status-history.enum';
import { TranslateModule } from '@ngx-translate/core';
import { ImgReadonlyHeaderComponent } from "../../../../../../../../../components/img-readonly-header/img-readonly-header.component";
import { TippyDirective } from '@ngneat/helipopper';
import { log } from '@angular-devkit/build-angular/src/builders/ssr-dev-server';
import { FinancialSetupModel } from '../../model-template/financial-setup.model';
import { TranslateService } from "@ngx-translate/core";
import { paymentTypeEnum } from '@app/pages/quote/standard-quote/model/standard-quote.model';
import { environment } from '@env/environment.local';


@Component({
    selector: 'app-general-information-readonly',
    standalone: true,
    templateUrl: './general-information-readonly.component.html',
    styleUrls: ['./general-information-readonly.component.css'],
    imports: [AppCommonModule, TemplateHistoryComponent, ImgReadonlyHeaderComponent, TippyDirective, TranslateModule],

})
export class GeneralInformationReadonlyComponent extends BaseComponent implements OnInit {

  readonly showFinancialSetupQuoteValidityDays =
    environment.showFinancialSetupQuoteValidityDays;
  readonly featureLoyaltyFeriaQuotation = environment.featureLoyaltyFeriaQuotation;

  private readonly translateService = inject(TranslateService);
    @ViewChild('modalTemplateConfirmation') modalTemplateConfirmation!: TemplateRef<any>;
    @ViewChild('modalTemplateHistory') modalTemplateHistory!: TemplateRef<any>;
    @ViewChild('modalTemplateRejection') modalTemplateRejection!: TemplateRef<any>;


    id: string | null = null;
    isLoading: boolean = false;
    financialSetup: FinancialSetupCreationDto | any;
    financialSetupHistory: FinancialSetupHistories | any;
    financialProductsList = financialProductsList;
    public purchaseOptionTypes = purchaseOptionTypes;
    public residualValueTypes = residualValueTypes;
    public taxTypes = taxTypes;
    public warrantyTypes = warrantyTypes;
    public optionsProductTypes = optionsProductTypes
    public filtersInsuranceType = filtersInsuranceType;
    protected readonly filterTypes = filterTypes;
    allowedActions = allowedActions;
    module = '';
    motive: string = '';
    rejectionReason: string = '';
    versions: FinancialSetupVersion[] = [];
    selectedVersion: FinancialSetupCreationDto;
    version: any = '';
    title: string = 'Eliminar paquete financiero';
    subtitle: string = '';
    btn1: string = 'Cancelar';
    btn2: string = 'Eliminar';
    idSetup: string;


    constructor(private router: Router,
        private authService: AuthService,
        private financialSetupService: FinancialSetupService,
        public activatedRoute: ActivatedRoute,
        private modalService: ModalService

    ) {
        super();

    }

    ngOnInit() {
        this.module = this.sendDataToMenu();
        //set  ip params
        this.activatedRoute.params.subscribe((params: any) => {
            this.id = params.id;
            this.getFinancialSetup();
        });
    }


    isRejected() {
        if (!this.financialSetup) return false;
        return 'REJECTED' === this.financialSetup?.status;
    }

    isDeprecated() {
        if (!this.financialSetup) return false;
        return 'DEPRECATED' === this.financialSetup?.status;
    }



    isInApprovalStatus() {
        return this.financialSetup?.status === 'IN_APPROVAL';
    }

    isApprovedStatus() {
        return this.financialSetup?.status == 'APPROVED';
    }

    showActions(){
        if (this.isAdministratorRole()){
            if (this.isApprovedStatus() || (this.isDeprecated())){
                return false;
            }
            return true;
        }
        return false;
    }




    showDescriptionFromTaxType(taxType: string | undefined) {
        return this.taxTypes.find((tax) => tax.value === taxType)?.display || '';
    }

    showWarranty(warranty: string | undefined) {
        return this.warrantyTypes.find((tax) => tax.value === warranty)?.display || '';
    }


    showPurchaseOptionType(purchaseOptionType: string | undefined) {
        return purchaseOptionTypes.find((purchase) => purchase.value === purchaseOptionType)?.display || '';
    }

    showResidualValueType(residualValueType: string | undefined) {
        return residualValueTypes.find((residual) => residual.value === residualValueType)?.display || '';
    }

    getFinancialSetup(id?: any) {
        this.isLoading = true;
        const financialSetupId = id || this.id;
        this.financialSetupService.getFinancialSetupById(financialSetupId).subscribe({
            next: (response) => {
                this.isLoading = false;
                this.financialSetup = response.data;
                this.financialSetupHistory = this.financialSetup?.financialSetupHistories || [];
                this.version = this.financialSetup?.version || '';
                this.versions = this.financialSetup?.versions;
                if (this.isRejected() && this.financialSetupHistory.length > 0) {
                    const rejectedHistories = this.financialSetupHistory.filter((f: FinancialSetupHistories) => f.action === StatusHistory.rejected);
                    const latestHistory = rejectedHistories.length > 0 ? rejectedHistories[rejectedHistories.length - 1] : null;
                    this.rejectionReason = latestHistory?.comments?.trim() || 'No hay motivo de rechazo disponible';
                }
                // console.log(this.financialSetup);
            },
            error: (error) => {
                this.isLoading = false;
                console.error(error);
            }
        });
    }
    getPaymentTypeSetup() {
      const paymentType = this.financialSetup?.paymentType;
      if (paymentType == paymentTypeEnum.expiration) {
        return "Vencido"
      } else if(paymentType == paymentTypeEnum.prepaid) {
        return "Anticipado"
      }
      return "";
    }

    onVersionChange(newVersion: number) {
        const selectedVersion = this.versions.find(version => version.version === newVersion);
        if (selectedVersion) {
            this.router.navigate(['financial-setup/read-only/' + selectedVersion.financialSetupId])
        }
    }


    back() {
        this.router.navigate(['financial-setup/list'],);
    }

    close() {
        this.modalService.closeModal();
    }

    edit() {
        this.router.navigate([`/quote/financial-setup/edit-setup/${this.id}`]);
    }

    remove() {
        this.isLoading = true;
        this.financialSetupService.deleteSetup(this.id).subscribe({
            next: (data) => {
                this.showNotificationSuccess('Paquete financiero eliminado correctamente',
                )
                this.isLoading = false;
                this.modalService.closeModal();
                this.router.navigate(['financial-setup/list'],);
            },
            error: (error) => {
                this.showNotificationError(
                    'Ha ocurrido un error, el paquete financiero no se pudo eliminar.'
                );
                this.isLoading = false;

            }
        })
    }

    request() {
        this.isLoading = true;
        this.financialSetupService.requestApproveFinancialSetup(this.id).subscribe({
            next: (data: any) => {
                this.showNotificationSuccess('Pedido de aprobación realizado con éxito',
                )
                this.isLoading = false;
                this.router.navigate(['financial-setup/list'],);
            },
            error: (error: any) => {
                this.isLoading = false;
                this.showNotificationError('Ha ocurrido un error, no se pudo realizar el pedido de aprobación.')
                console.error(error);
            }
        });
    }

    formatFinancialProduct(financialProduct: string | undefined) {
        return this.financialProductsList.find((product) => product.value === financialProduct)?.name || '';
    }

    formatCompanyName(companyName: string | undefined) {
        return formatFinancialSetupCompanyDisplay(companyName ?? '');
    }

    showClassification(classification: boolean | undefined) {
        return classification ? 'Nuevo' : 'Usado';
    }

    isCreditDirect() {
        return this.financialSetup?.financialProduct === FinancialProductEnum.directCredit;
    }

    iPureLease() {
        return this.financialSetup?.financialProduct === FinancialProductEnum.pureLease;
    }

    iCreditGlobe() {
        return this.financialSetup?.financialProduct === FinancialProductEnum.directCreditGlobe;
    }

    isFinancialLeasing() {
        return this.financialSetup?.financialProduct === FinancialProductEnum.financialLeasing;
    }

    isDCBalloon() {
        return this.financialSetup?.financialProduct === FinancialProductEnum.directCreditGlobe;
      }

  showPaymentFormationType(paymentFormationType: string | undefined) {
    return this.purchaseOptionTypes.find((payment) => payment.value === paymentFormationType)?.display || '';
  }

    showProductType(productType: string | undefined) {
        return filtersProductType.find((product) => product.value === productType)?.description || '';
    }

    showTotalByType(productType: any) {
        if (!productType || !this.financialSetup || !this.financialSetup.financialSetupModels) {
            return;
        }

        const total = this.financialSetup.financialSetupModels
            .filter((item: FinancialSetupModel) => item.modelType === productType.value)
            .length;

        return total === 0 ? "(Todos)" : `(${total})`;
    }


    getUniqueProductTypes(productTypes: any[]): any[] {
        if (!productTypes || productTypes.length === 0) return [];

        const uniqueTypesMap = new Map<string, any>();
        productTypes.forEach((productType) => {
            if (productType?.type === filterTypes.PRODUCT_TYPE) {
                uniqueTypesMap.set(productType.value, productType);
            }
        });

        return Array.from(uniqueTypesMap.values());
    }


    showPersonType(personType: string | undefined) {
        return filterPersonType.find((person) => person.value === personType)?.description || '';
    }

    showQuoteType(quoteType: string | undefined) {
        return filterQuoteType.find((quote) => quote.value === quoteType)?.description || '';
    }

    showDealerType(dealerType: string | undefined) {
        return filterDealers.find((dealer) => dealer.value === dealerType)?.description || '';
    }

    showTotalByDealer() {
        if (!this.financialSetup.dealerIds) return "(0)";
        return `(${this.financialSetup.dealerIds.length})`;
      }

    showProductInsurance(insuranceType: string | undefined) {
        return filtersInsuranceType.find((insurance) => insurance.value === insuranceType)?.description || '';
    }

    showLifeInsurance(insuranceType: string | undefined) {
        return filterInsuranceLife.find((insurance) => insurance.value === insuranceType)?.description || '';
    }

    getInsurancesTypeList() {
        return this.financialSetup?.insurancesType?.split(',');
    }

    isSupervisorRole() {
        return this.authService
            .checkRoleFromParentMenu(
                Permission.financialSetup,
                RolesInternal.supervisor);
    }

    isAdministratorRole() {
        return this.authService
            .checkRoleFromParentMenu(
                Permission.financialSetup,
                RolesInternal.administrator);
    }

    openModalConfirmation() {
        this.modalService.component = this.modalTemplateConfirmation;
        this.modalService.openModal();
    }

    openModalHistory() {
        this.modalService.component = this.modalTemplateHistory;
        this.modalService.openModal();
    }

    openModalRejection(item: any) {
        this.idSetup = item.id;
        this.subtitle = `¿Confirma la eliminación del paquete financiero "${item.financialSetupName}"?`;
        this.modalService.component = this.modalTemplateRejection;
        this.modalService.openModal();
    }

    reject() {
        this.isLoading = true;
        this.financialSetupService.rejectFinancialSetup(this.id, this.motive).subscribe({
            next: (data: any) => {
                this.showNotificationSuccess('Paquete financiero rechazado correctamente',
                )
                this.isLoading = false;
                this.financialSetup!.status = 'REJECTED';
                this.isRejected();
                this.router.navigate(['financial-setup/list']);
                this.close()
            },
            error: (error: any) => {
                this.isLoading = false;
                this.showNotificationError('Ha ocurrido un error, el paquete financiero no se pudo rechazar.')
                console.error(error);
            }
        });
    }

    approve() {
        this.isLoading = true;
        this.financialSetupService.approveFinancialSetup(this.id).subscribe({
            next: (data: any) => {
                this.showNotificationSuccess('Paquete financiero aprobado correctamente',
                )
                this.isLoading = false;
                this.router.navigate(['financial-setup/list'],);
            },
            error: (error: any) => {
                this.isLoading = false;
                this.showNotificationError('Ha ocurrido un error, el paquete financiero no se pudo aprobar.');
                console.error(error);
            }
        });
    }

    isDraftStatus(): boolean {
        return this.financialSetup?.status === 'DRAFT';
    }

    canShowRequestButton(): boolean {
        // Mantener la validación original del estado DRAFT
        if (!this.isDraftStatus()) {
            return false;
        }

        // Agregar validación para excluir al supervisor
        if (this.authService.checkRoleFromParentMenu(
            Permission.financialSetup,
            RolesInternal.supervisor
        )) {
            return false;
        }

        return true;
    }

    createNewVersion(id: number) {
        this.isLoading = true;
        this.financialSetupService.createNewVersion(id).subscribe({
            next: (response) => {
                this.showNotificationSuccess(
                    'La nueva version del paquete ha sido creada con éxito.'
                );
                this.isLoading = false;
                const financialSetup = response.data;
                this.router.navigate([`/quote/financial-setup/edit-setup/${financialSetup.id}`]);
            },
            error: (error) => {
                this.showNotificationError(
                    'Ha ocurrido un error, no se pudo crear una nueva version.'
                );
                this.isLoading = false;
            }
        });
    }

    hasConditions(): boolean {
        return this.financialSetup?.financialConditions?.length > 0;
    }

    hasNextVersion(): boolean {
        if (!this.versions || this.versions.length === 0) return false;
        const currentVersion = this.financialSetup?.version;
        return this.versions.some((version) => version.version > currentVersion);
    }

    protected readonly DealerType = DealerType;
}

